import EnumAssuntoManifestacao from "@/types/administracao/ouvidoria/enum-assunto-manifestacao";
import { TableField, defaultCPFFormatter, defaultDateFormatter } from "../../table-field";

const numeroAno: TableField = {
    key: "NmAno",
    label: "Número/Ano",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const manifestante: TableField = {
    key: "IdUsuarioManifestante",
    label: "CPF manifestante",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
    formatter: (val: string) => val ? defaultCPFFormatter(val) : "-"
};
const assunto: TableField = {
    key: "IdAssunto",
    label: "Assunto",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
    formatter: (val: number) => EnumAssuntoManifestacao[val] ?? "-"
};
const dtCriacao: TableField = {
    key: "DataCriacao",
    label: "Data de criação",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
    formatter: (val: string) => val ? defaultDateFormatter(new Date(val)) : ""
};
const dtVencimento: TableField = {
    key: "DataVencimentoAtualizada",
    label: "Data de vencimento",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
    formatter: (val: string) => val ? defaultDateFormatter(new Date(val)) : ""
};
const actions = {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};

export const fieldsManifestacoes: TableField[] = [
    numeroAno,
    manifestante,
    assunto,
    dtCriacao,
    dtVencimento,
    actions,
];
